import Vue from 'vue';
import Component from 'vue-class-component';
import outSideClick from 'directives/outSideClick';
import getLastTld from 'common/services/utils/getLastTld';
import HorizontalHolder from 'common/components/HorizontalHolder/HorizontalHolder.vue';

@Component({
  props: {
    provinces: {
      required: true,
      type: Array,
      default: () => [],
    },
    categories: {
      required: true,
      type: Array,
      default: () => [],
    },
    selectedLocation: {
      default: '',
      type: String,
    },
    selectedCategory: {
      default: '',
      type: String,
    },
    searchValue: {
      default: '',
      type: String,
    },
    boxIsRemote: {
      required: true,
      type: Boolean,
    },
    categoryId: {
      default: '',
      type: String,
    },
    showHomeActivities: {
      type: Boolean,
      required: true,
    },
    loadMap: {
      default: false,
      type: Boolean,
    },
  },
  directives: {
    clickOutside: outSideClick.directive,
  },
  components: {
    HorizontalHolder,
  },
})
export default class FilterExperiencesComponent extends Vue {
  selectedSort = null;
  searchQuery = this.searchValue;
  optionToShow = '';
  onlineReservationOrdered = false;
  mounted() {
    if (this.allCategories.length <= 2)
      this.filters = this.filters.filter(
        categories => categories.title !== 'Categorías',
      );
  }
  filters = [
    {
      title: 'Reserva online',
      icon: 'outlined-bell',
    },
    {
      title: 'Mapa',
      icon: 'Map',
    },
    {
      title: 'Categorías',
      icon: 'Category',
    },
    {
      title: 'Locación',
      icon: 'Location',
    },
    {
      title: 'Ordenar',
      icon: 'sort',
    },
  ];
  sorts = [
    {
      title: 'Relevancia',
      criteria: null,
    },
    {
      title: 'Mejores calificaciones',
      criteria: 'rating',
    },
    {
      title: 'Cantidad de calificaciones',
      criteria: 'reviews_qty',
    },
    {
      title: 'Más nuevas',
      criteria: 'id',
    },
  ];
  selectedSort = this.sorts[0];
  allCategories = [
    {
      id: '0',
      name: 'Todas las categorías',
      slug: 'categorías',
      __typename: 'CategoryType',
    },
    ...this.categories,
  ];

  showFilter(filter) {
    if (this.boxIsRemote) {
      return filter.title !== 'Locación' && filter.title !== 'Mapa';
    }
    return true;
  }

  get allProvinces() {
    const newAllProvinces = [{ id: '0', name: 'Todas las locaciones' }];
    this.provinces.forEach(item => {
      const province = {};
      province.id = item.id;
      province.name = item.name;
      newAllProvinces.push(province);
    });

    const GBA_OESTE_ID = '231';
    const GBA_NORTE_ID = '229';
    const GBA_SUR_ID = '230';
    const CABA_ID = '2';

    return newAllProvinces.sort((a, b) => {
      if (a.name === b.name) return 0;
      if (a.name === 'Todas las locaciones') return -1;
      if (b.name === 'Todas las locaciones') return 1;
      // Orders gba with caba
      if (a.id === CABA_ID) return -1;
      if (b.id === CABA_ID) return 1;
      if (a.id === GBA_NORTE_ID) return -1;
      if (b.id === GBA_NORTE_ID) return 1;
      if (a.id === GBA_SUR_ID) return -1;
      if (b.id === GBA_SUR_ID) return 1;
      if (a.id === GBA_OESTE_ID) return -1;
      if (b.id === GBA_OESTE_ID) return 1;

      if (a.name < b.name) {
        return -1;
      } else if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  }

  get isArg() {
    const isArg = getLastTld() === 'ar';
    return isArg;
  }
  /**
   * BaseBoxView handles this event.
   */
  changeSort(sort) {
    this.selectedSort = sort;
    if (sort.title !== 'Reserva online') {
      this.optionToShow = '';
      this.onlineReservationOrdered = false;
    }
    this.$emit('changesort', sort);
    this.$emit('modaltoggle');
  }

  inHomeClicked() {
    this.$emit('inhomefilter');
  }
  /**
   * BaseBoxView handles this event.
   */
  changeLocation(provinceId) {
    if (this.selectedLocation !== provinceId) {
      this.$emit('changelocation', provinceId);
    }
    this.optionToShow = '';
    this.$emit('modaltoggle');
  }
  /**
   * BaseBoxView handles this event.
   */
  changeCategory(categoryId) {
    if (this.selectedCategory !== categoryId) {
      this.$emit('changeCategory', categoryId);
    }
    this.optionToShow = '';
    this.$emit('modaltoggle');
  }
  /**
   * BaseBoxView handles this event.
   */
  changeOptionToShow(option) {
    if (option === 'reserva online') {
      this.toggleOnlineReservationOrder();
      return;
    }

    if (this.optionToShow === option) {
      this.optionToShow = null;
    } else {
      this.optionToShow = option;
    }

    this.$emit('modaltoggle');
    if (option === 'mapa') this.$emit('showMap');
  }

  clearSearchQuery() {
    this.searchQuery = '';
  }

  /**
   *
   * @param {string} target - Where the user clicked, necessary to differentiate
   * from the case of clicking outside of the component (an custom event is
   * necessary to remove the canvas at BaseBoxView)
   */
  hideFilterMenu(target) {
    if (this.optionToShow === 'reserva online') return;
    if (target === 'icon') {
      this.optionToShow = null;
      this.$emit('modaltoggle');
    } else {
      this.optionToShow = null;
    }
  }

  toggleOnlineReservationOrder() {
    this.onlineReservationOrdered = !this.onlineReservationOrdered;
    if (this.onlineReservationOrdered) {
      // sorts by online reservation
      const onlineReservationSort = {
        title: 'Reserva online',
        criteria: 'has_online_reservation',
      };
      this.changeSort(onlineReservationSort);
    } else {
      // reverts online reservation sort
      this.changeSort({
        title: '',
        criteria: null,
      });
    }
  }

  getFilterButtonTitle(filterItem) {
    const { title: categoryTitle } = filterItem;
    const categoryDataMap = {
      Locación: {
        selectedItem: this.selectedLocation,
        allItems: this.allProvinces,
      },
      Categorías: {
        selectedItem: this.selectedCategory,
        allItems: this.allCategories,
      },
    };

    if (
      categoryDataMap[categoryTitle] &&
      categoryDataMap[categoryTitle].selectedItem !== '0'
    ) {
      const selectedItem = categoryDataMap[categoryTitle].allItems.find(
        item => item.id === categoryDataMap[categoryTitle].selectedItem,
      );
      return selectedItem ? selectedItem.name : categoryTitle;
    }

    return categoryTitle;
  }
}
